import styled from 'styled-components';

export const InfoIcon = styled.img`
    width: 10px;
    margin: 0px 5px 3px 3px;
`;
